<template>
	<page gradient-background>
		<doc-base>
			<template #title>{{baseInfo.create_user_name}}_资产维修记录</template>

			<template #info>
				<c-field label="单据编号">{{baseInfo.document_number}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="资产编码">{{baseInfo.asset_code}}</c-field>
			<c-field label="资产名称">{{baseInfo.asset_name}}</c-field>
			<c-field label="资产分类">{{baseInfo.asset_category}}</c-field>
			<c-field label="单位">{{baseInfo.unit}}</c-field>
			<c-field label="所属网点">{{baseInfo.outlet_name}}</c-field>
			<c-field label="送修人">{{baseInfo.sender_user_name}}</c-field>
			<c-field label="送修时间">{{baseInfo.repair_time}}</c-field>
			<c-field label="维修类型"><c-state dict="repairTypeDic" :value="baseInfo.repair_type"></c-state></c-field>
			<c-field label="维修状态"><c-state dict="repairStatusDic" :value="baseInfo.status"></c-state></c-field>
			<c-field label="故障描述">{{baseInfo.repair_summary}}</c-field>
			<c-field label="备注">{{baseInfo.remark}}</c-field>

			<c-field v-if="baseInfo.status == 2" label="维修时间">{{baseInfo.finish_repair_time}}</c-field>
			<c-field v-if="baseInfo.status == 2" label="维修说明" colspan="2">{{baseInfo.finish_repair_remark}}</c-field>
		</doc-content>

		<doc-handle
			ref="docHandle"
		>
			<c-button v-if="auth('b_app_asset_repair_finish') && baseInfo.status == 1" size="detail" color="main" @click="finishHandle">完成维修</c-button>
			<c-button v-if="auth('b_app_asset_repair_edit') && baseInfo.status == 1" size="detail" color="red" @click="deleteHandle">删除</c-button>
			<c-button v-if="auth('b_app_asset_repair_edit') && baseInfo.status == 1" size="detail" @click="mp.navigateWeb('/assets/repair/edit', {id: baseInfo.id})">编辑</c-button>
		</doc-handle>

		<c-dialog ref="finish" title="完成维修">
			<c-form ref="finishForm">
            	<c-input type="hidden" name="id"></c-input>
				<c-form-item label="单据编号">
					<c-input name="document_number" disabled></c-input>
				</c-form-item>
				<c-form-item label="资产信息">
					<c-input name="asset_info" disabled></c-input>
				</c-form-item>
				<c-form-item label="维修时间" required>
					<c-datetime name="finish_time" type="datetime" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
				</c-form-item>
				<c-form-item label="维修说明">
					<c-input name="finish_remark" type="textarea" placeholder="请输入维修说明"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
				this.$refs.log.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/asset_repair_record/detail',
					data: {
						id: this.id
					},
					success: data => {
						this.baseInfo = data;
					}
				});
			},

			deleteHandle() {
				this.$confirm({
					message: '确定要删除该单据吗',
					resolve: () => {
						this.request({
							url: '/asset_repair_record/delete',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								setTimeout(() => {
									this.mp.navigateBack();
								}, 1000);
							}
						});
					}
				});
			},

			finishHandle() {
				this.$refs.finishForm.clear();
				this.$refs.finishForm.set({
					id: this.id,
					document_number: this.baseInfo.document_number,
					asset_info: `${this.baseInfo.asset_code} - ${this.baseInfo.asset_name}`,
					finish_time: new Date().format('yyyy-MM-dd hh:mm')
				});
				this.$refs.finish.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.finishForm.submit({
							url: '/asset_repair_record/complete',
							rule: {
								finish_time: '请选择维修时间'
							},
							success: () => {
								next();
								this.$message({
									message: '提交成功'
								});
								this.update();
							}
						})
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>